import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import EquipmentModelDropdown from '@/pages/Equipment/pages/EquipmentModels/components/EquipmentModelDropdown'
import ProtocolDropdown from '@/pages/Equipment/components/Common/ProtocolDropdown'
import OrganizationsMultiSelect from '@/pages/Organizations/components/OrganizationsMultiSelect'
import PassportSchemaDropdown from '@/pages/MDM/components/Passports/PassportSchemaDropdown'
import { TCreateEquipmentDTO } from '@/pages/Equipment/equipment.types.ts'
import { IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import TextArea from '@/shared/Inputs/TextArea'
import AntDatePicker from '@/shared/Inputs/DatePickers/AntDatePicker'
import UserMultiDropdownInput from 'src/pages/Users/components/UsersMultiDropdownInput'
import EquipmentLocationInput from './EquipmentLocationInput'

interface IProps {
  equipment: TCreateEquipmentDTO
  onChange: (val: any, key: string) => void

  passportSchemaId: IPassportSchema['id']
  onPassportSchemaChange: (passportSchemaId: IPassportSchema['id']) => void
}

const EquipmentFormFields = (props: IProps) => {
  const renderConnectionConfigurationInput = () => {
    if (props.equipment.protocolId === 'lp-lift') {
      return (
        <FormField label="ID контроллера" required={true}>
          <TextInput
            placeHolder="Введите ID контроллера"
            value={props.equipment.connectionConfiguration.controllerId}
            name="controllerId"
            onChange={(val) => props.onChange({ controllerId: val }, 'connectionConfiguration')}
          />
        </FormField>
      )
    }

    if (props.equipment.protocolId === 'lkds') {
      return (
        <FormField label="ID клиента" required={true}>
          <TextInput
            placeHolder="Введите ID клиента (например, LKDS_LU30016)"
            value={props.equipment.connectionConfiguration.clientId}
            name="clientId"
            onChange={(val) => props.onChange({ clientId: val }, 'connectionConfiguration')}
          />
        </FormField>
      )
    }
  }

  return (
    <>
      <FormField label="Адрес" required={true}>
        <EquipmentLocationInput
          location={props.equipment.location}
          onChange={(val) => props.onChange({ ...props.equipment.location, ...val }, 'location')}
        />
      </FormField>
      <FormField label="Уточнение адреса (подъезд, номер лифта и т.д.)" required={true}>
        <TextInput
          value={props.equipment.location.locationDescription}
          name="locationDescription"
          onChange={(val) => props.onChange({ ...props.equipment.location, locationDescription: val }, 'location')}
          placeHolder="Введите уточнение"
        />
      </FormField>
      <FormField label="Модель" required={true}>
        <EquipmentModelDropdown
          name="modelId"
          value={props.equipment.modelId}
          onChange={props.onChange}
          title="Выберите модель"
        />
      </FormField>
      <FormField label="Протокол" required={true}>
        <ProtocolDropdown value={props.equipment.protocolId} name="protocolId" onChange={props.onChange} />
      </FormField>
      <FormField label="Организации" required={true}>
        <OrganizationsMultiSelect
          selected={props.equipment.organizations}
          onSelect={props.onChange}
          name="organizations"
          title="Выберите организации"
        />
      </FormField>
      <FormField label="Ответственные">
        <UserMultiDropdownInput
          selectedUsersIds={props.equipment.responsibleUsers}
          onChange={props.onChange}
          name="responsibleUsers"
        />
      </FormField>
      <FormField label="Схема паспорта" required>
        <PassportSchemaDropdown
          value={props.passportSchemaId}
          name="passportSchemaId"
          onChange={props.onPassportSchemaChange}
        />
      </FormField>
      <FormField label="Дата старта обслуживания">
        <AntDatePicker
          selectedTs={
            props.equipment.maintenanceStartDate ? new Date(props.equipment.maintenanceStartDate).getTime() : null
          }
          onChange={(ts, name) => props.onChange(ts ? new Date(ts).toISOString() : ts, name)}
          name="maintenanceStartDate"
          withTime={false}
          allowSelectInFuture={true}
          format="DD.MM.YYYY"
        />
      </FormField>

      {renderConnectionConfigurationInput()}
      <FormField label="Описание или комментарий">
        <TextArea
          value={props.equipment.description}
          name="description"
          onChange={props.onChange}
          placeHolder="Описание или комментарий"
        />
      </FormField>
    </>
  )
}

export default EquipmentFormFields
